import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  stack: {
    marginBottom: theme.spacing(1),
  },
  labelText: {
    fontSize: '15px',
  },
  timerText: {
    fontSize: '49px',
  },
}));
